<template>
  <div>
    <div class="menu-box">
      <div class="item">
        <router-link to="/personal/personalIndex"><div class="title1" :class="{'active':activeM==1}">个人中心</div></router-link>
      </div>
      <div class="item">
        <div class="title">余额</div>
        <router-link to="/personal/personalMoney"><div class="menu" :class="{'active':activeM==2}">余额管理</div></router-link>
        <router-link to="/personal/Recharge"><div class="menu" :class="{'active':activeM==3}">充值管理</div></router-link>
        <router-link to="/personal/Withdrawal"><div class="menu" :class="{'active':activeM==4}">提现管理</div></router-link>
        <router-link to="/personal/Transfer"><div class="menu" :class="{'active':activeM==5}">转账管理</div></router-link>
        <router-link to="/personal/Business" v-if="userInfo.isBusiness"><div class="menu" :class="{'active':activeM==13}">业务员统计</div></router-link>
      </div>
      <div class="item flex-center-start">
        <div class="title">记录</div>
        <router-link to="/personal/SelfTest"><div class="menu" :class="{'active':activeM==6}">测试记录</div></router-link>
        <router-link v-if="Services.ClientId == 'MedicineDiagnosis.Web' && userInfo.organizationId == '290'" to="/personal/SelfTestTotal"><div class="menu" :class="{'active':activeM==20}">健康管理测试</div></router-link>
        <router-link to="/personal/Collect"><div class="menu" :class="{'active':activeM==7}">我的收藏</div></router-link>
        <router-link v-if="Services.ClientId == 'MedicineDiagnosis.Web'" to="/personal/Friend"><div class="menu" :class="{'active':activeM==15}">我的好友</div></router-link>
      </div>
      <div class="item flex-center-start">
        <div class="title">设置</div>
        <router-link to="/personal/userInfo"><div class="menu" :class="{'active':activeM==9}">个人资料</div></router-link>
        <router-link to="/personal/adressList"><div class="menu" :class="{'active':activeM==10}">地址管理</div></router-link>
        <router-link to="/personal/resetPassword"><div class="menu" :class="{'active':activeM==11}">修改密码</div></router-link>
        <router-link to="/personal/feedback"><div class="menu" :class="{'active':activeM==14}">意见反馈</div></router-link>
      </div>
      <div class="item">
        <div class="title1" :class="{'active':activeM==12}" @click="toDetail('/helpIndex')">用户手册</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="上传头像" width="30%">
      <el-form class="formBox">
        <el-form-item>
          <el-upload :headers="headers" :action="FileUploadUrl" class="avatar-uploader" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" style="text-align: center">
            <img v-if="imageUrl" :src="Services.ossUpload + imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePhoto">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo, userInfoLoad } from "../utils/userInfo";
import storage from "../utils/customstorage";
import { UserInfo } from "../components/User/UserInfo";
export default {
  name: "headerImg",
  inject: ["reload"],
  props:['active'],
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + storage.getItem("token"),
      };
    },
  },
  data() {
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);
    return {
      activeM:1,
      imageUrl: "",
      personalData: {},
      isgreenChannel: this.$store.state.localData.userInfo.isgreenChannel,
      dialogVisible: false,
      FileUploadUrl: `${this.Services.Statics}/api/upload`,
      userDomain: user,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
    };
  },
  mounted() {
    this.activeM=this.active
    this.personalData = getUserInfo();
  },
  methods: {
    toDetail(path) {
      const href = this.$router.resolve({
        path: path,
      });
      window.open(href.href, "_blank");
    },
    getUserVersion() {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    },
    handleSelect(key, keyPath) {
      if (key == "1") {
        // 个人中心
        this.$router.push("/personal/personalIndex");
      } else if (key == "1-1") {
        // 个人资料
        this.$router.push("/personal/userInfo");
      } else if (key == "2") {
        // 我的收藏
        this.$router.push("/personal/Collect");
      } else if (key == "3") {
        // 我的转诊
        this.$router.push("/personal/referral");
      } else if (key == "4") {
        // 我的接诊
        this.$router.push("/personal/treated");
      } else if (key == "5") {
        // 消息通知
        this.$router.push("/personal/Message");
      } else if (key == "6") {
        // 浏览记录
        this.$router.push("/personal/Browsing");
      } else if (key == "7") {
        // 修改密码
        this.$router.push("/personal/resetPassword");
      } else if (key == "9") {
        // 患者管理
        this.$router.push("/patienTmanagement/patientList");
      } else if (key == "10-1") {
        // 待审核管理
        this.$router.push("/patienTmanagement/prescriptList");
      } else if (key == "10-2") {
        // 处方管理
        this.$router.push("/patienTmanagement/stateprescriptList");
      } else if (key == "10-3") {
        // 处方管理
        this.$router.push("/patienTmanagement/successprescriptList");
      } else if (key == "8-1") {
        // 单视频管理
        this.$router.push("/video/videoList");
      } else if (key == "8-2") {
        this.$router.push("/video/collectList");
        // 视频合集管理
      } else if (key == "8-3") {
        // 视频销售统计
      } else if (key == "11") {
        // 绿色通道
        this.$router.push("/personal/SelfTest");
      } else if (key == "12") {
        // 绿色通道
        this.$router.push("/personal/SelfTestTotal");
      } else if (key == "13") {
        // 地址收货
        this.$router.push("/personal/adressList");
      } else if (key == "14") {
        // 地址收货
        this.$router.push("/personal/personalMoney");
      } else if (key == "15") {
        // 升级
        this.$router.push("/personal/upgrade");
      } else {
        // 绿色通道
        this.$router.push("/personal/greenChannel");
      }
    },
    uploadHeaderimg() {
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = `${res[0].completeFilePath}`;
      this.imageUrlData = `${res[0].completeFilePath}`;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    savePhoto: function () {
      var _this = this;
      var editeItem = _this.personalData;
      _this.userDomain.Edit(editeItem.id, editeItem.name, editeItem.phone, editeItem.userTitleId, editeItem.userPostId, editeItem.roleId, editeItem.organizationId != 0 ? editeItem.organizationId : null, editeItem.departmentId != 0 ? editeItem.departmentId : null, editeItem.telephone, editeItem.address, editeItem.abstract, _this.imageUrlData, function (data) {
        _this.$message({
          type: "success",
          message: "操作成功!",
        });
        _this.personalData.photo = _this.imageUrl;
        _this.$bus.$emit("userhead", _this.imageUrl);
        userInfoLoad(_this.personalData.name, _this.personalData.phone, _this.personalData.titleId, _this.personalData.postId, _this.personalData.telephone, _this.personalData.address, _this.personalData.abstract, _this.imageUrlData);
        _this.dialogVisible = false;
        _this.personalData = getUserInfo();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-menu-item .el-icon-truck {
  margin-right: 0px !important;
  width: 16px !important;
}
::v-deep .el-menu-item .el-icon-s-finance {
  margin-right: 0px !important;
  width: 16px !important;
}

.personal-headerImg {
  width: 260px;
  background: #1fb7a6;
  padding: 3px;
  border-radius: 5px;
  box-sizing: border-box;
}

.personal-headerImg .header-box {
  width: 254px;
  height: 205px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: #fafffe;
  overflow: hidden;
}

.personal-headerImg img {
  width: 100%;
  height: 100%;
}

.header-name {
  padding: 10px;
}

.header-name p {
  font-size: 16px;
  line-height: 1.5;
  color: #ffffff;
  font-weight: 700;
  text-align: center;
}

.header-name span {
  display: block;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}

.personal-nav {
  width: 185px;
  background: #ffffff;
  padding: 20px;
  box-sizing: border-box;
}

.personal-nav /deep/ .el-submenu__title {
  padding: 0 !important;
  background: none;
  color: #ffffff;
  margin-top: 7px;
}

.personal-nav ul li {
  border-bottom: 1px solid #e5e5e5;
  line-height: 48px;
  padding-left: 5px;
  cursor: pointer;
}

.personal-nav ul li i {
  font-size: 16px;
  color: #737373;
}

.personal-nav ul li span {
  margin-left: 5px;
  font-size: 15px;
  color: #737373;
}

.personal-nav ul .router-link-active li {
  background: #1fb7a6;
  line-height: 54px;
  border-radius: 10px;
  padding-left: 15px;
}

.personal-nav ul .router-link-active li i,
.personal-nav ul .router-link-active li span {
  color: #ffffff !important;
}

.personal-nav ul li:hover i,
.personal-nav ul li:hover span {
  color: #1fb7a6;
}
.formBox /deep/ .el-upload--text {
  width: 178px;
  height: 178px;
}
</style>
<style > 
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style scoped lang="scss">
.menu-box {
  width: 200px;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  padding: 5px 0;
}
.item {
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 20px;
  margin-top: 20px;
}
.item:last-child {
  border: none;
}
.title {
  margin-left: -25px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.title1 {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 2.5;
  width: 90%;
  margin: 0 auto;
  cursor: pointer;
}
.menu {
  line-height: 3;
  width: 90%;
  margin: 0 auto;
}
.active {
  height: 40px;
  background: #f2f2f2;
  border-radius: 6px;
  color: #00afb5 !important;

  a{
    color: #00afb5 !important;
  }
}
.menu:hover,.title1:hover{
  background: #f2f2f2;
  border-radius: 6px;
  color: #00afb5 !important;
  a{
    color: #00afb5 !important;
  }
}
</style>
